/* eslint import/prefer-default-export: 0 */

export const substance = {
  pvq: {
    intro: {
      title: 'Substance use',
      body:
      'You will be asked questions about your substance use and be asked to provide details if necessary.',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      title: 'Review your answers',
      para: 'View the full section to make sure everything looks right and make changes if needed.',
    },
    section: {
      name: 'Substance use',
    },
    comments: {
      optional: 'Optional Comment',
      summary: 'Optional Summary Comment'
    },
    subsection: {
      intro: 'Introduction',
      drugs: {
        label: 'Illegal use of drugs and drug activity',
        usage: 'Usage',
        purchase: 'Purchase',
        clearance: 'Security clearance position',
        publicsafety: 'Public safety position',
        misuse: 'Prescription drug misuse',
        negativeImpact: 'Negative Impact',
        ordered: 'Mandatory counseling or treatment',
        voluntary: 'Voluntary counseling or treatment',
        supplementalUsage: 'Supplemental usage',
        supplementalPublicSafety: 'Supplemental public safety position',
      },
      thc: {
        label: 'Marijuana and Cannabis Derivative Use',
        usage: 'Usage',
        purchase: 'Purchase',
        clearance: 'Security clearance position',
        publicsafety: 'Public safety position',
      },
      alcohol: {
        intro: 'Introduction',
        label: 'Use of alcohol',
        negative: 'Negative impact',
        ordered: 'Mandatory counseling or treatment',
        voluntary: 'Voluntary counseling or treatment',
        additional: 'Additional instances',
        any: 'Alcohol-related counseling or treatment'
      },
      review: 'Review',
    },
    destination: {
      intro: 'Substance use intro',
      'drugs/usage': 'Usage',
      'drugs/purchase': 'Purchase',
      'drugs/clearance': 'Security clearance position',
      'drugs/publicsafety': 'Public safety position',
      'drugs/misuse': 'Prescription drug misuse',
      'drugs/negativeimpact': 'Negative Impact',
      'drugs/ordered': 'Mandatory counseling or treatment',
      'drugs/voluntary': 'Voluntary counseling or treatment',
      'drugs/supplementalpublicsafety': 'Supplemental public safety position',
      'drugs/supplementalusage': 'Supplemental usage',
      'thc/intro': 'Introduction',
      'thc/usage': 'Usage',
      'thc/purchase': 'Purchase',
      'thc/clearance': 'Security clearance position',
      'thc/publicsafety': 'Public safety position',
      'alcohol/intro': 'Introduction',
      'alcohol/negative': 'Negative impact',
      'alcohol/ordered': 'Mandatory counseling or treatment',
      'alcohol/voluntary': 'Voluntary counseling or treatment',
      'alcohol/additional': 'Additional instances',
      'alcohol/supplemental': 'Alcohol-related Counseling or Treatment',
      police: {
        usage: 'Usage',
        negative: 'Negative impact',
        ordered: 'Mandatory counseling or treatment',
        voluntary: 'Voluntary counseling or treatment',
        additional: 'Additional instances',
      },
      drugs: {
        usage: 'Usage',
        purchase: 'Purchase',
        clearance: 'Security clearance position',
        publicsafety: 'Public safety position',
        misuse: 'Prescription drug misuse',
        ordered: 'Mandatory counseling or treatment',
        voluntary: 'Voluntary counseling or treatment',
        supplementalpublicsafety: 'Supplemental public safety position',
        supplementalusage: 'Supplemental usage',
      },
      thc: {
        usage: 'Usage',
        purchase: 'Purchase',
        clearance: 'Security clearance position',
        publicsafety: 'Public safety position',
      },
      review: 'Review substance use',
    },
    alcohol: {
      heading: {
        title: 'Section 19: Use of Alcohol and Rehabilitative Actions',
        negativeImpact:
          'Has the use of alcohol negatively impacted your life in the past five years (or since the age of 16 if you are under 21)? (For example, have you experienced poor work or school performance; professional or personal relationship problems; or, financial, legal, or health issues?)',
        orderedCounseling:
          'Were you ordered to get counseling or treatment as a result of alcohol use in the past five years (or since the age of 16 if you are under 21)?',
        orderedCounselingNum:
          'In the last {{numberOfYearsString}} have you been ordered, advised, or asked to seek counseling or treatment as a result of your use of alcohol?',
        voluntaryCounseling:
          'Have you voluntarily been to counseling or treatment as a result of your alcohol use in the past five years (or since the age of 16 if you are under 21)?',
        voluntaryCounselingNum:
          'In the last {{numberOfYearsString}} have you voluntarily sought counseling or treatment as a result of your use of alcohol?',
        receivedCounseling:
          'Have you EVER received counseling or treatment as a result of your use of alcohol in addition to what you have already listed on this form?',
        anyCounseling:
          'In the last 5 years, has your use of alcoholic beverages (such as liquor, beer, wine) resulted in any alcohol-related treatment or counseling (such as for alcohol abuse or alcoholism)?'
      },
      para: {
        intro1:
                'This section asks for information regarding the extent of your alcohol consumption, its impacts on your personal and professional activities, if any, and any actions you have taken to overcome alcohol-related concerns, as applicable.',
      },
      negativeImpact: {
        heading: {
          whenAffected: 'When was your life negatively affected?',
          impact: 'How has your alcohol use negatively impacted your life?',
        },
        label: {
          circumstances: 'Provide circumstances',
          negativeImpact: 'Provide negative impact',
        },
        help: {
          occurred: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          circumstances: {
            title: 'Need help with the circumstances?',
            message: 'Provide an explanation of the circumstances and the negative impact',
            note: '',
          },
          whenAffected: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
        collection: {
          description: 'Summary of negative impacts',
          summary: 'Provide your negative impact details below',
          appendTitle:
            'Has the use of alcohol had other negative impacts on your work performance, your professional or personal relationships, your finances, or resulted in intervention by law enforcement/public safety personnel?',
          appendLabel: 'Add another negative impact',
          itemType: 'Negative impact',
        },
      },
      orderedCounseling: {
        heading: {
          orderedBy: 'Who ordered you to get this counseling or treatment? (Check one. There will be an opportunity to input multiple entries.)',
          orderedByOther: 'Please explain.',
          actionTaken: 'Did you get this counseling or treatment?',
          noActionTakenExplanation:
            'Please explain. (Include why you did not get this counseling or treatment, the consequences of not getting it, if any, and any other details you think are important.)',
          counselingDates: 'When did you get this counseling or treatment?',
          treatmentProviderName: 'Who is or was your counselor or treatment provider?',
          address: 'Is your counselor, treatment provider, or the practice in the U.S.?',
          addressDomesticTitle: 'What is the address of your counselor, treatment provider, or the practice?',
          addressForeignTitle: 'Where is your counselor, treatment provider, or the practice located?',
          treatmentProviderTelephone: 'What is their phone number? (You may list more than one.)',
          treatmentProviderEmail: 'What is their email address? (You may list more than one.)',
          completedTreatment: 'Did you complete this counseling or treatment?',
          noCompletedTreatment:
            'What is the current status of your counseling or treatment?',
          treatmentStatus: 'What is the current status of your counseling or treatment?'
        },
        para: {
          or: 'or',
        },
        label: {
          idk: "I Don't Know",
          explain: 'Please explain',
          seekers: 'Check all that apply',
          otherSeeker: 'Provide explanation',
        },
        collection: {
          description: 'Summary of counselings',
          summary: 'Provide your counseling details below',
          appendTitle:
            'Do you have another instance where you were ordered to get counseling or treatment as a result of your alcohol use in the past five years (or since the age of 16 if you are under 21) to report?',
          appendLabel: 'Add another counseling',
          itemType: 'Counseling',
        },
        help: {
          seekers: {
            title: 'Need help with determining who has ordered you to seek treatment?',
            message:
              'Check all who ordered, advised, or asked you to seek counseling or treatment as a result of your use of alcohol',
            note: '',
          },
          counselingDates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          actionTaken: {
            title: 'Need help with action taken to seek counseling or treatment',
            message: 'Select if you have taken action to seek counseling or treatment.',
            note: '',
          },
          treatmentProviderName: {
            title: 'Need help with the treatment provider name?',
            message: 'Provide the name of the individual counselor or treatment provider',
            note: '',
          },
          treatmentProviderAddress: {
            title:
              "Try looking up the treatment provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          treatmentProviderTelephone: {
            title: 'Look up the treatment provider',
            message:
              "Try looking up the treatment provider's name, this could help you find the phone number.",
            note: '',
          },
          completedTreatment: {
            title: 'Need help with your treatment completion?',
            message: 'Mark if you successfully completed a treatment program',
            note: '',
          },
        },
      },
      voluntaryCounseling: {
        heading: {
          recommendedBy: 'Was this voluntary counseling based on advice or a recommendation from one or more of the following? (Select all that apply.)',
          recommendedByExplanation: 'Please explain',
          counselingDates: 'When did you get this counseling or treatment?',
          treatmentProviderName: 'Who is or was your counselor or treatment provider?',
          treatmentProviderPracticeName: 'What is the name of the practice?',
          address: 'Is your counselor, treatment provider, or the practice in the U.S.?',
          addressDomesticTitle: 'What is the address of your counselor, treatment provider, or the practice?',
          addressForeignTitle: 'Where is your counselor, treatment provider, or the practice located?',
          treatmentProviderTelephone: 'What is their phone number? (You may list more than one.)',
          treatmentProviderEmail: 'What is their email address? (You may list more than one.)',
          completedTreatment: 'Did you complete this counseling or treatment?',
          noCompletedTreatment:
            'What is the current status of your counseling or treatment?',
          providerStillPractices: 'Does your counselor or treatment provider still practice?',
        },
        collection: {
          description: 'Summary of counselings',
          summary: 'Provide your counseling details below',
          appendTitle:
            'Do you have any other voluntary counseling or treatments to report?',
          appendLabel: 'Add another counseling',
          itemType: 'Counseling',
        },
        para: {
          or: 'or',
        },
        label: {
          idk: "I Don't Know",
        },
        help: {
          counselingDates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentProviderName: {
            title: 'Need help with the treatment provider name?',
            message: 'Provide the name of the individual counselor or treatment provider',
            note: '',
          },
          treatmentProviderAddress: {
            title:
              "Try looking up the treatment provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          treatmentProviderTelephone: {
            title: 'Look up the treatment provider',
            message:
              "Try looking up the treatment provider's name, this could help you find the phone number.",
            note: '',
          },
          completedTreatment: {
            title: 'Need help with your treatment completion?',
            message: 'Mark if you successfully completed a treatment program',
            note: '',
          },
          noCompletedTreatment: {
            title: 'Need help with this explanation?',
            message:
              'Provide details as to why you responded No to having successfully completed the treatment program',
            note: '',
          },
        },
      },
      receivedCounseling: {
        heading: {
          counselingDates: 'Provide the dates of counseling or treatment',
          treatmentProviderName: 'Provide the name of the individual counselor or treatment provider',
          treatmentProviderAddress: 'Provide the full address of the counseling/treatment provider',
          agencyName:
            'Provide the name of agency/organization where counseling/treatment was provided',
          agencyAddress:
            'Provide the address of agency/organization where counseling/treatment was provided',
          completedTreatment: 'Did you successfully complete your counseling or treatment?',
          treatmentBeganDate: 'Provide the date counseling or treatment began',
          treatmentEndDate: 'Provide the date counseling or treatment ended',
          noCompletedTreatment: 'Provide explanation',
        },
        collection: {
          description: 'Summary of counselings',
          summary: 'Provide your counseling details below',
          appendTitle: 'Did you receive alcohol-related counseling or treatment another time?',
          appendLabel: 'Add another counseling',
          itemType: 'Counseling',
        },
        help: {
          counselingDates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentProviderName: {
            title: 'Need help with the treatment provider name?',
            message: 'Provide the name of the individual counselor or treatment provider',
            note: '',
          },
          treatmentProviderAddress: {
            title:
              "Try looking up the treatment provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          agencyName: {
            title: 'Need help with the agency name?',
            message:
              'Provide the name of agency/organization where counseling/treatment was provided',
            note: '',
          },
          agencyAddress: {
            title: "Try looking up the agency's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          treatmentBeganDate: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentEndDate: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          completedTreatment: {
            title: 'Need help with your treatment completion?',
            message: 'Mark if you successfully completed a treatment program',
            note: '',
          },
          noCompletedTreatment: {
            title: 'Need help with this explanation?',
            message:
              'Provide details as to why you responded No to having successfully completed the treatment program',
            note: '',
          },
        },
      },
      anyCounseling: {
        heading: {
          counselingSummaryComment: 'Optional Summary Comment',
          alcoholTreatmentOrCounselingComment: 'Optional Comment',
          consultationComment: 'Optional Comment',
          treatmentProviderName: 'Provide the name of the counselor or doctor',
          counselingDates: 'Provide the dates of treatment',
          treatmentProviderAddress: 'Provide the address of the counselor or doctor',
        },
        collection: {
          description: 'Summary of counselings',
          summary: 'Provide your counseling details below',
          appendTitle:
            'Do you have an additional instance of having your use of alcohol beverages (such as liquor, beer, wine) result in any alcohol-related treatment or conseling (such as for alcohol abuse or alcoholism) in the last 5 years to enter?',
          appendLabel: 'Add another counseling',
          itemType: 'Counseling',
        },
        help: {
          counselingDates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentProviderAddress: {
            title: "Try looking up the provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
        },
      },
    },
    drugs: {
      intro: {
        title: 'Section 12 - Drug Activity: Introduction',
        body: ['This section asks for information regarding your use of illegal drugs or misuse of controlled substances (excluding marijuana or cannabis derivatives which are discussed in the next section) or prescription drugs as applicable. Questions focus on the type of illegal drugs, controlled substances, or prescription drugs; the frequency of your use; the circumstances surrounding your use; the impacts on your personal and professional activities; and any actions you\'ve taken to overcome any drug-related concerns, as applicable. Your truthful responses and any information derived from your responses will not be used as evidence against you in a subsequent criminal proceeding. This applies whether or not you are employed by the Federal government.',
          'For this section:',
          '- A controlled substance is as defined in 21 U.S.C. 802.',
          '- A prescription drug (also referred to as prescription medication or prescription medicine) is a pharmaceutical drug that legally requires a medical prescription to be dispensed.',
          '- An illegal drug is a drug or substance which a person is forbidden by law to own, possess, distribute, or use.',
          '- Use of a drug or controlled substance includes injecting, snorting, smoking, inhaling, swallowing, experimenting with, or otherwise consuming any drug or controlled substance. ',
          '- Report your use of an illegal drug or your misuse of a controlled substance or prescription drug whether or not you were arrested, charged, or convicted of breaking any laws.',
          '- Report drugs or controlled substances (excluding marijuana or cannabis derivatives which are discussed in the next section) that are illegal under federal law, even if legal under state or foreign (non-U.S.) laws.'],
      },
      heading: {
        drugUses:
        'Have you used an illegal drug or misused a controlled substance (excluding marijuana or cannabis derivatives) in the past five years or since the age of 16 (if you are under 21)?',
        drugInvolvement:
        'Have you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold any drug or controlled substance (excluding marijuana or cannabis derivatives) in the past five years or since the age of 16 (if you are under 21)?',
        drugClearanceUses:
        'Have you EVER used an illegal drug or misused a controlled substance (excluding marijuana or cannabis derivatives) while in a national security position? (Answer "No" if this occurred in the past five years and you listed it above.) (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature of the position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)  ',
        drugPublicSafetyUses:
        'Have you ever used an illegal drug or misused a controlled substance (excluding marijuana or cannabis derivatives) while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock" or "on duty". Answer "No" if this occurred in the past five years and you listed it above.)',
        drugPublicSafetyUsesNum:
        'In the last {{numberOfYearsString}} have you illegally used or otherwise been involved with a drug or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety other than previously listed?',
        prescriptionUses:
        'Have you intentionally misused drugs prescribed for you or someone else in the past five years or since the age of 16 (if you are under 21) and have not previously reported it on this form? ("Intentionally" means you deliberately misused prescription drugs as opposed to accidently.)',
        orderedTreatments:
        'Were you ordered to get counseling or treatment as a result of your illegal use of drugs or controlled substances (excluding marijuana or cannabis derivatives), or your misuse of prescription drugs in the past five years or since the age of 16 (if you are under 21)?',
        orderedTreatmentsEver:
        'Were you ordered to get counseling or treatment as a result of your illegal use of drugs or controlled substances (excluding marijuana or cannabis derivatives), or your misuse of prescription drugs in the past five years or since the age of 16 (if you are under 21)? ',
        voluntaryTreatments:
        'Have you voluntarily been to counseling or treatment as a result of your illegal use of drugs or controlled substances (excluding marijuana or cannabis derivatives), or your misuse of prescription drug in the past five years or since the age of 16 (if you are under 21)?',
        voluntaryTreatmentsEver:
        'Have you EVER voluntarily sought counseling or treatment as a result of your use of a drug or controlled substance?',
        supplementalUsage: 'Since the age of 16 or in the last 5 years, whichever is shorter, have you illegally used any controlled substance, for example, marijuana, cocaine, crack cocaine, hashish, narcotics (opium, morphine, codeine, heroine, etc.), amphetamines, depressants (barbiturates, methaqualone, tranquilizers, etc.), hallucinogenics (LSD, PCP, etc.) or prescription drugs?',
        supplementalPublicSafety: 'Have you ever illegally used a controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; while possessing a security clearance; or while in a position directly and immediately affecting the public safety?',
        negativeImpact: 'Has your use of an illegal drug or misuse of a controlled substance (excluding marijuana or cannabis derivatives) or prescription drug negatively impacted your life in the past five years or since the age of 16 (if you are under 21)? (For example, have you experienced poor work or school performance; professional or personal relationship problems; or, financial, legal, or health issues.)'
      },
      para: {
        drugUses:
        'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding. This particular section applies whether or not you are currently employed by the Federal government. The following questions pertain to the illegal use of drugs or controlled substances or drug or controlled substance activity not in accordance with Federal laws, even though permissible under state laws.',
      },
      use: {
        heading: {
          drugType: 'What type of illegal drug did you use or controlled substance did you misuse, excluding marijuana or cannabis derivatives?  (Check one. There will be an opportunity to input multiple entries.) ',
          otherDrugType: 'Please explain.',
          firstUse: 'When was the first time you used this illegal drug or misused this controlled substance?',
          recentUse: 'When was the last time you used this illegal drug or misused this controlled substance?',
          howManyTimes: 'How many times did you use this illegal drug or misuse this controlled substance?',
          reason: 'What were the circumstances surrounding your use of this illegal drug or misuse of this controlled substance?',
          useWhileEmployed:
          'Did you use this illegal drug or misuse this controlled substance while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock" or "on duty".)',
          useWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          useWhileEmployedExplanation: 'Please explain. (Include when and how many times you used this illegal drug or misused this controlled substance while employed in a criminal justice or public safety position.)',
          useWithClearance: 'Did you use this illegal drug or misuse this controlled substance while in a national security position? (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature of the position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)',
          useWithClearanceExplanation: 'Please explain. (Include when and how many times you used this illegal drug or misused this controlled substance while in a national security position)',
          useInFuture: 'Do you intend to use this illegal drug or misuse this controlled substance in the future?',
          useInFutureExplanation:
          'Why?',
        },
        para: {
          drugUses:
          'Use of a drug or controlled substance includes injecting, snorting, inhaling, swallowing, experimenting with or otherwise consuming any drug or controlled substance.',
        },
        help: {
          drugType: {
            title: 'Need help with the drug type?',
            message: 'Provide the type of drug or controlled substance used',
            note: '',
          },
          firstUse: {
            title: 'Need help with the date of first use?',
            message: 'Provide an estimate of the month and year of first use',
            note: '',
          },
          recentUse: {
            title: 'Need help with the date of most recent use?',
            message: 'Provide an estimate of the month and year of first use',
            note: '',
          },
          natureOfUse: {
            title: 'Need help with the nature of drug use?',
            message: 'Provide nature of use, frequency, and number of times used',
            note: '',
          },
          useWhileEmployed: {
            title: 'Need help with the use?',
            message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
            note: '',
          },
          useWithClearance: {
            title: 'Need help with the drug use with a security clearance?',
            message: 'Was your use while possessing a security clearance?',
            note: '',
          },
          useInFuture: {
            title: 'Need help with the drug use in the future?',
            message: 'Mark if you intend to use this drug or controlled substance in the future',
            note: '',
          },
          explanation: {
            title: 'Need help with the explanation?',
            message:
            'Provide explanation of why you intend or do not intend to use this drug or controlled substance in the future',
            note: '',
          },
        },
        collection: {
          description: 'Summary of drug uses',
          summary: 'Provide your drug use details below',
          appendTitle:
          'Do you have another instance of using an illegal drug or misusing a controlled substance (excluding marijuana or cannabis derivatives) in the past five years or since the age of 16 (if you are under 21) to report?',
          appendLabel: 'Add another drug use',
          itemType: 'Drug Use',
        },
      },
      negativeImpact: {
        heading: {
          impact: 'How has your use of an illegal drug or misuse of a controlled substance (excluding marijuana or cannabis derivatives) or prescription drug negatively affected your life?',
          impactDates: 'When was your life negatively affected?',
        },
      },
      involvement: {
        heading: {
          firstInvolvement: 'When was the first time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance?',
          recentInvolvement: 'When was the last time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance?',

          drugType: 'What type of drug or controlled substance did you illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell? (Check one. There will be an opportunity to input multiple entries.)',
          otherDrugType: 'Please explain.',
          firstUse: 'When was the first time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance?',
          recentUse: 'When was the last time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance?',
          howManyTimes: 'How many times did you illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell this drug or controlled substance?',
          reasons: 'What were the circumstances surrounding your illegal possession, purchase, manufacturing, cultivation, trafficking, production, transference, shipping, receiving, handling, or selling of this drug or controlled substance?',
          requireAlcoholSections: 'What were the circumstances surrounding your use of this illegal drug or misuse of this controlled substance while employed in a criminal justice or public safety position?',
          involvementWhileEmployed:
          'Did you illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell this drug or controlled substance while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock" or "on duty".)',
          involvementWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          involvementWhileEmployedExplanation: 'Please explain. (Include when and how many times you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance while employed in a criminal justice or public safety position.) ',
          involvementWithClearance: 'Did you illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell this drug or controlled substance while in a national security position? (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature of the position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)  ',
          involvementWithClearanceExplanation: 'Please explain. (Include when and how many times you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this drug or controlled substance while in a national security position.)',
          involvementInFuture: 'Do you intend to illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell this drug or controlled substance in the future?',
          explanation: 'Why?',
        },
        help: {
          drugType: {
            title: 'Need help with the drug type?',
            message: 'Provide the type of drug or controlled substance used',
            note: '',
          },
          firstInvolvement: {
            title: 'Need help with the date of first involvement?',
            message: 'Provide an estimate of the month and year of first involvement',
            note: '',
          },
          recentInvolvement: {
            title: 'Need help with the date of most recent involvement?',
            message: 'Provide an estimate of the month and year of first involvement',
            note: '',
          },
          natureOfInvolvement: {
            title: 'Need help with the nature of drug involvement?',
            message: 'Provide nature of use, frequency, and number of times used',
            note: '',
          },
          involvementWhileEmployed: {
            title: 'Need help with the use?',
            message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
            note: '',
          },
          involvementWithClearance: {
            title: 'Need help with the drug use with a security clearance?',
            message: 'Was your use while possessing a security clearance?',
            note: '',
          },
          involvementInFuture: {
            title: 'Need help with the drug use in the future?',
            message: 'Mark if you intend to use this drug or controlled substance in the future',
            note: '',
          },
          reasons: {
            title: 'Need help with the reasoning?',
            message: 'Provide the reason(s) why you engaged in the activity',
            note: '',
          },
          explanation: {
            title: 'Need help with the explanation?',
            message:
            'Provide explanation of why you intend or do not intend to use this drug or controlled substance in the future',
            note: '',
          },
        },
        collection: {
          description: 'Summary of drug involvement',
          summary: 'Provide your drug involvement details below',
          appendTitle:
          'Do you have another instance of illegally possessing, purchasing, manufacturing, cultivating, trafficking, producing, transferring, shipping, receiving, handling, or selling any drug or controlled substance (excluding marijuana or cannabis derivatives)  in the past five years or since the age of 16 (if you are under 21) to report? ',
          appendLabel: 'Add another drug involvement',
          itemType: 'Drug involvement',
        },
      },
      clearance: {
        heading: {
          drugType: 'What type of drug did you illegally use or controlled substance did you misuse while in a national security position? (Check one. There will be an opportunity to input multiple entries.)',
          otherDrugType: 'Please explain.',
          firstUse: 'When was the first time you used this illegal drug or misused this controlled substance while in a national security position?',
          recentUse: 'When was the last time you used this illegal drug or misused this controlled substance while in a national security position?',
          howManyTimes: 'How many times did you use this illegal drug or misuse this controlled substance while in a national security position?',
          reason: 'What were the circumstances surrounding your use of this illegal drug or misuse of this controlled substance while in a national security position?',
          involvementDatesFrom: 'When was the first time you used this illegal drug or misused this controlled substance while in a national security position?',
          involvementDatesTo: 'When was the last time you used this illegal drug or misused this controlled substance while in a national security position?',
        },
        help: {
          description: {
            title: 'Need help with the description?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          involvementDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          estimatedUse: {
            title: 'Need help with the estimated times used?',
            message:
            'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while possessing a security clearance',
            note: '',
          },
        },
        collection: {
          description: 'Summary of drug involvement',
          summary: 'Provide your drug involvement details below',
          appendTitle:
          'Do you have an additional instance(s) of the illegal use or involvement with a drug or controlled substance while possessing a security clearance to enter?',
          appendLabel: 'Add another drug involvement',
          itemType: 'Drug involvement',
        },
      },
      publicSafety: {
        heading: {
          description:
          'Provide a description of the drugs or controlled substances used and your involvement',
          involvementDates: 'Provide the dates of involvement/use',
          estimatedUse:
          'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while employed in this capacity',
          drugType: 'What type of drug did you illegally use or controlled substance did you misuse while employed in a criminal justice or public safety position? (Check one. There will be an opportunity to input multiple entries.)',
          otherDrugType: 'Please explain.',
          firstUse: 'When was the first time you used this illegal drug or misused this controlled substance while employed in a criminal justice or public safety position?',
          recentUse: 'When was the last time you used this illegal drug or misused this controlled substance while employed in a criminal justice or public safety position?',
          howManyTimes: 'How many times did you use this illegal drug or misuse this controlled substance while employed in a criminal justice or public safety position?',
          reason: 'What were the circumstances surrounding your use of this illegal drug or misuse of this controlled substance while employed in a criminal justice or public safety position?',
          useWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          useWhileEmployedPositionExplanation: 'Please explain.',
          involvementDatesFrom: 'When was the first time you used this illegal drug or misused this controlled substance while employed in a criminal justice or public safety position?',
          involvementDatesTo: 'When was the last time you used this illegal drug or misused this controlled substance while employed in a criminal justice or public safety position?',
        },
        help: {
          description: {
            title: 'Need help with the description?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          involvementDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          estimatedUse: {
            title: 'Need help with the estimated times used?',
            message:
            'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while possessing a security clearance',
            note: '',
          },
        },
        collection: {
          description: 'Summary of drug involvement',
          summary: 'Provide your drug involvement details below',
          appendTitle:
          'Do you have an additional instance(s) of illegal use or involvement with a drug or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety to enter?',
          appendLabel: 'Add another drug involvement',
          itemType: 'Drug involvement',
        },
      },
      prescription: {
        heading: {
          prescriptionName: 'What prescription drug did you intentionally misuse? (List one at a time. There will be an opportunity to input multiple entries.)',
          involvementDateFrom: 'When was the first time you intentionally misused this prescription drug?',
          involvementDateTo: 'When was the last time you intentionally misused this prescription drug?',
          drugType: 'What type of illegal drug did you use or controlled substance did you misuse? (Check one. There will be an opportunity to input multiple entries.)',
          otherDrugType: 'Please explain.',
          firstUse: 'When was the first time you used this illegal drug or misused this controlled substance?',
          recentUse: 'When was the last time you used this illegal drug or misused this controlled substance?',
          howManyTimes: 'How many times did you intentionally misuse this prescription drug?',
          reason: 'What were the circumstances surrounding your intentional misuse of this prescription drug?',
          useWhileEmployed:
          'Did you intentionally misuse this prescription drug while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock" or "on duty".)',
          useWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          useWhileEmployedExplanation: 'Please explain. (Include when and how many times you intentionally misused this prescription drug while employed in a criminal justice or public safety position.)',
          useWithClearance: 'Did you intentionally misuse this prescription drug while in a national security position?',
          useWithClearanceExplanation: 'Please explain. (Include when and how many times you intentionally misused this prescription drug while in a national security position.)',
          useInFuture: 'Do you intend to misuse this or any other prescription drugs in the future?',
          useInFutureExplanation:
          'Why?',
        },
        help: {
          prescriptionName: {
            title: 'Need help with the prescriptin name?',
            message: 'Provide the name of the prescription drug that you misused',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message:
            'Provide the reason(s) for and circumstances of the misuse of the prescription drug',
            note: '',
          },
          involvementDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          useWhileEmployed: {
            title: 'Need help with the use?',
            message:
            'Was your involvement while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
            note: '',
          },
          useWithClearance: {
            title: 'Need help with the drug use with a security clearance?',
            message: 'Was your involvement while possessing a security clearance?',
            note: '',
          },
        },
        collection: {
          description: 'Summary of drug misuse',
          summary: 'Provide your drug misuse details below',
          appendTitle:
          'Do you have another instance of intentionally misusing prescription drugs in the past five years or since the age of 16 (if you are under 21) to report? ("Intentionally" means you deliberately misused prescription drugs as opposed to accidently.)',
          appendLabel: 'Add another drug misuse',
          itemType: 'Drug misuse',
        },
      },
      ordered: {
        heading: {
          orderedBy: 'Who ordered you to get this counseling or treatment? (Check one. There will be an opportunity to input multiple entries.)',
          orderedByOther: 'explain who ordered you to get this counseling or treatment',
          explanation: 'Please explain.',
          actionTaken: 'Did you get this counseling or treatment?',
          noActionTakenExplanation:
          'Please explain. (Include why you did not get this counseling or treatment, the consequences of not getting it, if any, and any other important details.)',
          dueToPrescription: 'Was this order a result of your intentional misuse of prescription drugs?',
          prescriptionDrug: 'What is the name of the prescription drug? (List all, if more than one.)',
          dueToDrugs: 'Was this order a result of your illegal use of drugs or controlled substances?',
          drugTypes: 'What is the type of drug or controlled substance? (Select all that apply.)',
          drugTypeOther: 'Please explain.',
          treatmentProvider: 'Who is or was your counselor or treatment provider?',
          treatmentProvideridk: 'I don\'t know',
          treatmentProvideror: '-Or-',
          treatmentProviderInPractice: 'Does your treatment provider still practice?',
          treatmentProviderPracticeName: 'What is the name of the practice?',
          treatmentProviderEmails: 'What is their phone number? (You may list more than one.)',
          treatmentProviderPhoneNumbers: 'What is their email address? (You may list more than one.)',
          treatmentProviderAddress: 'Is your counselor, treatment provider, or the practice in the U.S.?',
          treatmentProviderDomesticAddress: 'What is the address of your counselor, treatment provider, or the practice?',
          treatmentProviderForeignAddress: 'Where is your counselor, treatment provider, or the practice located?',
          treatmentProviderTelephone: 'Provide a telephone number for the treatment provider',
          treatmentDates: 'When did you get this counseling or treatment?',
          treatmentCompleted: 'Did you complete this counseling or treatment?',
          treatmentExplanation: 'What is the current status of your counseling or treatment?',
          treatmentProviderAddressDomesticTitle: 'What is the address of your counselor, treatment provider, or the practice?',
          treatmentProviderAddressForeignTitle: 'Where is your counselor, treatment provider, or the practice located?',
          noTreatmentExplanation: 'Why was treatment not completed?',
          treatmentStatus: 'What is the current status of your counseling or treatment?',
          phoneNumbers: {
            title: 'What is their phone number? (You may list more than one.)',
            append: 'Do you have another phone numbers to add?',
            branch: {
              title: 'Can you provide a phone number?',
            },
          },
          emails: {
            title: 'What is their email address? (You may list more than one.)',
            append: 'Do you have another email address to add?',
            branch: {
              title: 'Can you provide an email address?',
            },
          },
        },
        para: {
          orderedBy: 'Check all that apply',
          treatmentProviderFirstName: 'First name',
          treatmentProviderLastName: 'Last name',
        },
        help: {
          drugType: {
            title: 'Need help with the drug type?',
            message: 'Provide the type of drug or controlled substance used',
            note: '',
          },
          orderedBy: {
            title: 'Need help with who ordered treatment?',
            message:
            'Have any of the following ordered, advised, or asked you to seek counseling or treatment as a result of your illegal use of drugs or controlled substances?',
            note: '',
          },
          explanation: {
            title: 'Need help with the explanation?',
            message: 'Provide explanation',
            note: '',
          },
          actionTaken: {
            title: 'Need help with taking action to receive counseling or treatment?',
            message: 'Mark if you took action to receive counseling or treatment',
            note: '',
          },
          noActionTakenExplanation: {
            title: 'Need help with not having taken action?',
            message: 'Provide explanation as to why you did not receive treatment',
            note: '',
          },
          treatmentProvider: {
            title: 'Need help with the treatment provider?',
            message: 'Provide the name of the treatment provider',
            note: '',
          },
          treatmentProviderAddress: {
            title: "Try looking up the provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          treatmentProviderTelephone: {
            title: 'Look up the provider',
            message: "Try looking up the provider's name, this could help you find the phone number.",
            note: '',
          },
          treatmentDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentCompleted: {
            title: 'Need help with the treatment completion?',
            message: 'Mark yes if you successfully completed the treatment',
            note: '',
          },
          noTreatmentExplanation: {
            title: 'Need help with the explanation for not completing treatment?',
            message: 'Explain why you did not complete treatment',
            note: '',
          },
        },
        collection: {
          description: 'Summary of treatments',
          summary: 'Provide your treatment details below',
          appendTitle:
          'Do you have another instance where you were ordered to get counseling or treatment as a result of your illegal use of drugs, controlled substances(excluding marijuana or cannabis derivatives), or misuse of prescription drugs in the past five years or since the age of 16 (if you are under 21) to report?',
          appendLabel: 'Add another treatment',
          itemType: 'Treatment',
        },
        orderedBy: {
          label: {
            employer: 'Employer',
            militaryCommander: 'Military Commander',
            medicalProfessional: 'Medical Professional',
            mentalHealthProfessional: 'Mental Health Professional',
            judge: 'Court Official/Judge',
            none:
            'I have not been ordered, advised, or asked to seek counseling or treatment by any of the above.',
          },
        },
      },
      voluntary: {
        heading: {
          recommendedBy: 'Was this voluntary counseling based on advice or a recommendation from one or more of the following? (Select all that apply.)',
          explanation: 'Please explain.',
          actionTaken: 'Did you get this counseling or treatment?',
          noActionTakenExplanation:
          'Please explain. (Include why you did not get this counseling or treatment, the consequences of not getting it, if any, and any other important details.)',
          dueToPrescription: 'Is or was your counseling or treatment a result of your intentional misuse of prescription drugs?',
          prescriptionDrug: 'What is the name of the prescription drug? (List all, if more than one.)',
          dueToDrugs: 'Is or was your counseling or treatment a result of your illegal use of drugs or controlled substances?',
          drugTypes: 'What is the type of drug or controlled substance? (Select all that apply.)',
          drugTypeOther: 'Please explain.',
          treatmentProvider: 'Who is or was your counselor or treatment provider?',
          treatmentProvideridk: 'I don\'t know',
          treatmentProviderInPractice: 'Does your treatment provider still practice?',
          treatmentProviderPracticeName: 'What is the name of the practice?',
          treatmentProviderEmails: 'What is their phone number? (You may list more than one.)',
          treatmentProviderPhoneNumbers: 'What is their email address? (You may list more than one.)',
          treatmentProviderAddress: 'Is your counselor, treatment provider, or the practice in the U.S.?',
          treatmentProviderDomesticAddress: 'What is the address of your counselor, treatment provider, or the practice?',
          treatmentProviderForeignAddress: 'Where is your counselor, treatment provider, or the practice located?',
          treatmentProviderTelephone: 'Provide a telephone number for the treatment provider',
          treatmentDates: 'When did you get this counseling or treatment?',
          treatmentCompleted: 'Did you complete this counseling or treatment?',
          treatmentExplanation: 'What is the current status of your counseling or treatment?',
          treatmentProviderAddressDomesticTitle: 'What is the address of your counselor, treatment provider, or the practice?',
          treatmentProviderAddressForeignTitle: 'Where is your counselor, treatment provider, or the practice located?',
          noTreatmentExplanation: 'Why was treatment not completed?',
          treatmentStatus: 'What is the current status of your counseling or treatment?',
          phoneNumbers: {
            title: 'What is their phone number? (You may list more than one.)',
            append: 'Do you have another phone numbers to add?',
            branch: {
              title: 'Can you provide a phone number?',
            },
          },
          emails: {
            title: 'What is their email address? (You may list more than one.)',
            append: 'Do you have another email address to add?',
            branch: {
              title: 'Can you provide a email address',
            },
          },
        },
        para: {
          treatmentProviderFirstName: 'First name',
          treatmentProviderLastName: 'Last name',
          or: 'or',
        },
        label: {
          idk: "I don't know",
        },
        help: {
          drugType: {
            title: 'Need help with the drug type?',
            message: 'Provide the type of drug or controlled substance used',
            note: '',
          },
          treatmentProvider: {
            title: 'Need help with the treatment provider?',
            message: 'Provide the name of the treatment provider',
            note: '',
          },
          treatmentProviderAddress: {
            title: "Try looking up the provider's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          treatmentProviderTelephone: {
            title: 'Look up the provider',
            message: "Try looking up the provider's name, this could help you find the phone number.",
            note: '',
          },
          treatmentDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates gives us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          treatmentCompleted: {
            title: 'Need help with the treatment completion?',
            message: 'Mark yes if you successfully completed the treatment',
            note: '',
          },
          noTreatmentExplanation: {
            title: 'Need help with the explanation for not completing treatment?',
            message: 'Explain why you did not complete treatment',
            note: '',
          },
        },
        collection: {
          description: 'Summary of treatments',
          summary: 'Provide your treatment details below',
          appendTitle:
          'Do you have another instance where you voluntarily went to counseling or treatment as a result of your illegal use of drugs, controlled substances, or misuse of prescription drugs in the past five years or since the age of 16 (if you are under 21) to report?',
          appendTitleEver:
          'Do you have another instance where you voluntarily went to counseling or treatment as a result of your illegal use of drugs, controlled substances, or misuse of prescription drugs in the past five years or since the age of 16 (if you are under 21) to report?',
          appendLabel: 'Add another treatment',
          itemType: 'Treatment',
        },
        orderedBy: {
          label: {
            employer: 'An employer, military commander, or employee assistance program',
            medicalProfessional: 'A medical professional',
            mentalHealthProfessional: 'A mental health professional',
            judge: 'A court official / judge',
            none: 'I have not been ordered, advised, or asked to seek counseling or treatment by any of the above.',
          },
        },
      },
      supplementalPublicSafety: {
        heading: {
          drugUsed: 'Identify the controlled substance and/or prescription drug used',
          dateRange: 'Provide the dates used',
          numberOfTimesUsed: 'Provide the number of times used',
          comment: 'Optional Comment',
          branchComment: 'Optional Comment',
          summaryComment: 'Optional Summary Comment'
        },
        help: {
          drugUsed: {
            title: 'Need help with the the controlled substance and/or prescription drug used?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          dateRange: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          numberOfTimesUsed: {
            title: 'Need help with the number of times used?',
            message:
            'Provide the number of times the controlled substance and/or prescription drug was used',
            note: '',
          },
        },
        collection: {
          description: 'Summary of controlled substance involvement',
          summary: 'Provide your controlled substance involvement details below',
          appendTitle:
          'Do you have an additional instance of having ever illegally used a controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; while possessing a security clearance; or while in a position directly and immediately affecting the public safety to enter?',
          appendLabel: 'Add another controlled substance involvement',
          itemType: 'Supplemental public safety instance',
        },
      },
      supplementalUsage: {
        heading: {
          drugUsed: 'Identify the controlled substance and/or prescription drug used',
          dateRange: 'Provide the dates used',
          numberOfTimesUsed: 'Provide the number of times used',
          comment: 'Optional Comment',
          branchComment: 'Optional Comment',
          summaryComment: 'Optional Summary Comment'
        },
        help: {
          drugUsed: {
            title: 'Need help with the the controlled substance and/or prescription drug used?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          dateRange: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          numberOfTimesUsed: {
            title: 'Need help with the number of times used?',
            message:
            'Provide the number of times the controlled substance and/or prescription drug was used',
            note: '',
          },
        },
        collection: {
          description: 'Summary of controlled substance involvement',
          summary: 'Provide your controlled substance involvement details below',
          appendTitle:
          'Do you have an additional instance of having illegally used any controlled substance or prescription drugs since the age of 16 or in the last 5 years, whichever is shorter, to enter?',
          appendLabel: 'Add another controlled substance involvement',
          itemType: 'Supplemental usage instance',
        },
      },

      drugType: {
        label: {
          cocaine: 'Cocaine or crack cocaine (Such as rock, freebase, etc.)',
          stimulants: 'Stimulants (Such as amphetamines, speed, crystal meth, or ecstasy)',
          thc: 'THC (Such as marijuana, weed, pot, or hashish)',
          depressants: 'Depressants (Such as barbiturates, methaqualone, or tranquilizers)',
          ketamine: 'Ketamine (Such as special K, jet, etc.)',
          narcotics: 'Narcotics (Such as opium, morphine, codeine, or heroin)',
          hallucinogenic: 'Hallucinogenic (Such as LSD, PCP, or mushrooms)',
          steroids: 'Steroids (Such as the clear or juice)',
          inhalants: 'Inhalants (Such as toluene or amyl nitrate)',
          other: 'Other',
          drugTypeOther: 'Provide explanation',
        },
      },
    },
    thc: {
      intro: {
        title: 'Section 13 - Marijuana and Cannabis Derivative Use: Introduction',
        body: 'In this section, “marijuana and cannabis derivative use,” cannabis derivative refers to any cannabis-derived substance containing greater than .3% tetrahydrocannabinol (THC). You do NOT need to answer yes to questions regarding your use of cannabis derivatives if you have solely used products that did not exceed .3% THC, such as most products containing CBD oil. Your truthful responses and any information derived from your responses will not be used as evidence against you in a criminal proceeding',
      },
      heading: {
        thcUses:
        'Have you used marijuana or a cannabis derivative in the last 90 days?',
        thcInvolvement:
        'In the past five years, have you been involved in the illegal manufacture, cultivation, trafficking, production, transfer, shipping, receiving, or sale of marijuana or a cannabis derivative?',
        thcClearanceUses:
        'Have you ever used marijuana or a cannabis derivative while in a national security position? (Answer "No" if this occurred in the past 90 days and you listed it above.) ',
        thcPublicSafetyUses:
        'Have you ever used marijuana or a cannabis derivative while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock” or “on duty".) (Answer "No" if this occurred in the past 90 days and you listed it above.)',
        thcPublicSafetyUsesNum:
        'In the last {{numberOfYearsString}} have you illegally used or otherwise been involved with a thc or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety other than previously listed?',
      },
      para: {
        thcUses:
        'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding. This particular section applies whether or not you are currently employed by the Federal government. The following questions pertain to the illegal use of thc or controlled substances or thc or controlled substance activity not in accordance with Federal laws, even though permissible under state laws.',
      },
      use: {
        heading: {
          firstUse: 'When, within the last five years, was the first time you used marijuana or a cannabis derivative?',
          recentUse: 'When, within the last five years, was the most recent time you used marijuana or a cannabis derivative?',
          howManyTimes: 'How often have you used marijuana or a cannabis derivative in the last five years?',
          reason: 'What were the circumstances surrounding your use of marijuana or a cannabis derivative?',
          useWhileEmployed:
          'Did you use marijuana or a cannabis derivative while employed in a criminal justice or public safety position in the last 90 days? ("While employed" does not necessarily mean your use was "on the clock” or “on duty".)',
          useWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          useWhileEmployedExplanation: 'Please explain. (Include when and how many times you used marijuana or a cannabis derivative while employed in a criminal justice or public safety position.)',
          useWithClearance: 'Did you use marijuana or a cannabis derivative while in a national security position in the last 90 days? (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)',
          useWithClearanceExplanation: 'Please explain. (Include when and how many times you used marijuana or a cannabis derivative while in a national security position.)',
          useInFutureClearance: 'Do you intend to use marijuana or a cannabis derivative in the future if you are selected for employment in a criminal justice, public safety, or national security position? ',
          useInFutureClearanceExplanation:
          'Why?',
          useInFutureClearanceOrSafety: 'Do you intend to use marijuana or a cannabis derivative in the future if you are selected for employment in a criminal justice, public safety, or national security position? ',
          useInFutureClearanceOrSafetyExplanation:
          'Why?',
          useInFutureGovernment: 'Do you intend to use marijuana or a cannabis derivative in the future while occupying any position working for or on behalf of the federal government? ',
          useInFutureGovernmentExplanation:
          'Why?',
        },
        para: {
          thcUses:
          'Use of a thc or controlled substance includes injecting, snorting, inhaling, swallowing, experimenting with or otherwise consuming any thc or controlled substance.',
        },
        help: {
          thcType: {
            title: 'Need help with the thc type?',
            message: 'Provide the type of thc or controlled substance used',
            note: '',
          },
          firstUse: {
            title: 'Need help with the date of first use?',
            message: 'Provide an estimate of the month and year of first use',
            note: '',
          },
          recentUse: {
            title: 'Need help with the date of most recent use?',
            message: 'Provide an estimate of the month and year of first use',
            note: '',
          },
          natureOfUse: {
            title: 'Need help with the nature of thc use?',
            message: 'Provide nature of use, frequency, and number of times used',
            note: '',
          },
          useWhileEmployed: {
            title: 'Need help with the use?',
            message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
            note: '',
          },
          useWithClearance: {
            title: 'Need help with the thc use with a security clearance?',
            message: 'Was your use while possessing a security clearance?',
            note: '',
          },
          useInFuture: {
            title: 'Need help with the thc use in the future?',
            message: 'Mark if you intend to use this thc or controlled substance in the future',
            note: '',
          },
          explanation: {
            title: 'Need help with the explanation?',
            message:
            'Provide explanation of why you intend or do not intend to use this thc or controlled substance in the future',
            note: '',
          },
        },
        collection: {
          description: 'Summary of thc uses',
          summary: 'Provide your thc use details below',
          appendTitle:
          'Do you have another instance of using marijuana or a cannabis derivative in the last 90 days?',
          appendLabel: 'Add another thc use',
          itemType: 'THC Use',
        },
      },
      involvement: {
        heading: {
          firstInvolvement: 'When was the approximate start date of your involvement in the described activity?',
          recentInvolvement: 'When was the approximate end date of your involvement in the described activity?',
          reasons: 'Describe the circumstances of your involvement in the described activity?',
          thcType: 'What type of thc or controlled substance did you illegally possess, purchase, manufacture, cultivate, traffic, produce, transfer, ship, receive, handle, or sell? (Check one. There will be an opportunity to input multiple entries.)',
          otherTHCType: 'Please explain.',
          firstUse: 'When was the first time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this thc or controlled substance?',
          recentUse: 'When was the last time you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this thc or controlled substance?',
          howManyTimes: 'How many times did you illegally manufacture, cultivate, traffic, produce, transfer, ship, receive, or sell marijuana or a cannabis derivative?',
          requireAlcoholSections: 'What were the circumstances surrounding your use of this illegal thc or misuse of this controlled substance while employed in a criminal justice or public safety position?',
          involvementWhileEmployed:
          'Did you illegally manufacture, cultivate, traffic, produce, transfer, ship, receive, or sell marijuana or a cannabis derivative while employed in a criminal justice or public safety position? ("While employed" does not necessarily mean your use was "on the clock” or “on duty".)',
          involvementWhileEmployedPosition: 'What criminal justice or public safety position were you in?',
          involvementWhileEmployedExplanation: 'Please explain. (Include when and how many times you illegally manufactured, cultivated, trafficked, produced, transferred, shipped, received, or sold marijuana or a cannabis derivative while employed in a criminal justice or public safety position. ',
          involvementWithClearance: 'Did you illegally manufacture, cultivate, traffic, produce, transfer, ship, receive, or sell marijuana or a cannabis derivative while in a national security position? (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature of the position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)',
          involvementWithClearanceExplanation: 'Please explain. (Include when and how many times you illegally possessed, purchased, manufactured, cultivated, trafficked, produced, transferred, shipped, received, handled, or sold this thc or controlled substance while in a national security position.)',
          involvementInFuture: 'Do you intend to illegally manufacture, cultivate, traffic, produce, transfer, ship, receive, or sell marijuana or a cannabis derivative in the future if you are selected for employment in a criminal justice, public safety, or national security position? (A national security position is defined as any position in a department or agency, where the occupant of which could bring about, by virtue of the nature of the position, a material adverse effect on the national security regardless of whether the occupant has access to classified information and regardless of whether the occupant is an employee, military service member, or contractor.)',
          involvementInFutureExplanation: 'Why?',
          involvementInFutureGovernment: 'Do you intend to illegally manufacture, cultivate, traffic, produce, transfer, ship, receive, or sell marijuana or a cannabis derivative in the future while occupying any position working for or on behalf of the federal government?',
          involvementInFutureGovernmentExplanation: 'Why?',

        },
        help: {
          thcType: {
            title: 'Need help with the thc type?',
            message: 'Provide the type of thc or controlled substance used',
            note: '',
          },
          firstInvolvement: {
            title: 'Need help with the date of first involvement?',
            message: 'Provide an estimate of the month and year of first involvement',
            note: '',
          },
          recentInvolvement: {
            title: 'Need help with the date of most recent involvement?',
            message: 'Provide an estimate of the month and year of first involvement',
            note: '',
          },
          natureOfInvolvement: {
            title: 'Need help with the nature of thc involvement?',
            message: 'Provide nature of use, frequency, and number of times used',
            note: '',
          },
          involvementWhileEmployed: {
            title: 'Need help with the use?',
            message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
            note: '',
          },
          involvementWithClearance: {
            title: 'Need help with the thc use with a security clearance?',
            message: 'Was your use while possessing a security clearance?',
            note: '',
          },
          involvementInFuture: {
            title: 'Need help with the thc use in the future?',
            message: 'Mark if you intend to use this thc or controlled substance in the future',
            note: '',
          },
          reasons: {
            title: 'Need help with the reasoning?',
            message: 'Provide the reason(s) why you engaged in the activity',
            note: '',
          },
          explanation: {
            title: 'Need help with the explanation?',
            message:
            'Provide explanation of why you intend or do not intend to use this thc or controlled substance in the future',
            note: '',
          },
        },
        collection: {
          description: 'Summary of thc involvement',
          summary: 'Provide your thc involvement details below',
          appendTitle:
          'Do you have another instance of having been involved in the illegal manufacture, cultivation, trafficking, production, transfer, shipping, receiving, or sale of marijuana or cannabis derivative?',
          appendLabel: 'Add another thc involvement',
          itemType: 'THC involvement',
        },
      },
      clearance: {
        heading: {
          firstUse: 'When was the first time you used marijuana or a cannabis derivative while in a national security position?',
          recentUse: 'When was the most recent time you used marijuana or a cannabis derivative while in a national security position?',
          frequency: 'How often did you use marijuana or a cannabis derivative while in a national security position?',
          howManyTimes: 'How many times did you use marijuana or a cannabis derivative while in this national security position?',
          reason: 'What were the circumstances surrounding your use of marijuana or a cannabis derivative while in a national security position?',
          involvementDatesFrom: 'When was the first time you used marijuana or a cannabis derivative while in a national security position?',
          involvementDatesTo: 'When was the most recent time you used marijuana or a cannabis derivative while in a national security position?',
        },
        help: {
          description: {
            title: 'Need help with the description?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          involvementDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          estimatedUse: {
            title: 'Need help with the estimated times used?',
            message:
            'Provide an estimate of the number of times you used and/or were involved with this thc or controlled substance while possessing a security clearance',
            note: '',
          },
        },
        collection: {
          description: 'Summary of marijuana or a cannabis derivative involvement',
          summary: 'Provide your marijuana or a cannabis derivative involvement details below',
          appendTitle:
          'Do you have another instance of using marijuana or a cannabis derivative while in a national security position to report?',
          appendLabel: 'Add another marijuana or a cannabis derivative involvement',
          itemType: 'marijuana or a cannabis derivative involvement',
        },
      },
      publicSafety: {
        heading: {
          description:
          'Provide a description of the thc or controlled substances used and your involvement',
          involvementDates: 'Provide the dates of involvement/use',
          estimatedUse:
          'How often did you use marijuana or a cannabis derivative while in a criminal justice or public safety position?',
          firstUse: 'When was the first time you used marijuana or a cannabis derivative while in a criminal justice or public safety position?',
          recentUse: 'When was the last time you used marijuana or a cannabis derivative while in a criminal justice or public safety position?',
          frequency: 'How often did you use marijuana or a cannabis derivative while in a criminal justice or public safety position ?',
          howManyTimes: 'How many times did you use marijuana or a cannabis derivative while in a criminal justice or public safety position?',
          reason: 'What were the circumstances surrounding your use of marijuana or a cannabis derivative while in this criminal justice or public safety position?',
          useWhileEmployedPosition: 'What criminal justice or public safety position were you in when you used marijuana or a cannabis derivative?',
          useWhileEmployedPositionExplanation: 'Please explain. (Include when and how many times you used this illegal thc or misused this controlled substance while employed in a criminal justice or public safety position.)',
          involvementDatesFrom: 'When was the first time you used marijuana or a cannabis derivative while in a criminal justice or public safety position?',
          involvementDatesTo: 'When was the last time you used marijuana or a cannabis derivative while in a criminal justice or public safety position?',
        },
        help: {
          description: {
            title: 'Need help with the description?',
            message: 'Provide a description of your involvement',
            note: '',
          },
          involvementDates: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          estimatedUse: {
            title: 'Need help with the estimated times used?',
            message:
            'Provide an estimate of the number of times you used and/or were involved with this thc or controlled substance while possessing a security clearance',
            note: '',
          },
        },
        collection: {
          description: 'Summary of marijuana or a cannabis derivative involvement',
          summary: 'Provide your marijuana or a cannabis derivative involvement details below',
          appendTitle:
          'Do you have another instance of using marijuana or a cannabis derivative while in a criminal justice or public safety position to report?',
          appendLabel: 'Add another marijuana or a cannabis derivative involvement',
          itemType: 'marijuana or a cannabis derivative involvement',
        },
      },

    },
  },
  intro: {
    title: 'Substance use',
    body:
      'You will be asked questions about your substance use and be asked to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    title: 'Review your answers',
    para: 'View the full section to make sure everything looks right and make changes if needed.',
  },
  section: {
    name: 'Substance use',
  },
  comments: {
    optional: 'Optional Comment',
    summary: 'Optional Summary Comment'
  },
  subsection: {
    intro: 'Introduction',
    drugs: {
      label: 'Illegal use of drugs and drug activity',
      usage: 'Usage',
      purchase: 'Purchase',
      clearance: 'Security clearance position',
      publicsafety: 'Public safety position',
      misuse: 'Prescription drug misuse',
      negativeImpact: 'Negative Impact',
      ordered: 'Mandatory counseling or treatment',
      voluntary: 'Voluntary counseling or treatment',
      supplementalUsage: 'Supplemental usage',
      supplementalPublicSafety: 'Supplemental public safety position',
    },
    thc: {
      label: 'Marijuana and Cannabis Derivative Use',
      usage: 'Usage',
      purchase: 'Purchase',
      clearance: 'Security clearance position',
      publicsafety: 'Public safety position',
    },
    alcohol: {
      label: 'Use of alcohol',
      negative: 'Negative impact',
      ordered: 'Mandatory counseling or treatment',
      voluntary: 'Voluntary counseling or treatment',
      additional: 'Additional instances',
      any: 'Alcohol-related counseling or treatment'
    },
    review: 'Review',
  },
  destination: {
    intro: 'Substance use intro',
    'drugs/intro': 'Introduction',
    'drugs/usage': 'Usage',
    'drugs/purchase': 'Purchase',
    'drugs/clearance': 'Security clearance position',
    'drugs/publicsafety': 'Public safety position',
    'drugs/misuse': 'Prescription drug misuse',
    'drugs/negativeimpact': 'Negative Impact',
    'drugs/ordered': 'Mandatory counseling or treatment',
    'drugs/voluntary': 'Voluntary counseling or treatment',
    'drugs/supplementalpublicsafety': 'Supplemental public safety position',
    'drugs/supplementalusage': 'Supplemental usage',
    'thc/intro': 'Introduction',
    'thc/usage': 'Usage',
    'thc/purchase': 'Purchase',
    'thc/clearance': 'Security clearance position',
    'thc/publicsafety': 'Public safety position',
    'alcohol/intro': 'Introduction',
    'alcohol/negative': 'Negative impact',
    'alcohol/ordered': 'Mandatory counseling or treatment',
    'alcohol/voluntary': 'Voluntary counseling or treatment',
    'alcohol/additional': 'Additional instances',
    'alcohol/supplemental': 'Alcohol-related Counseling or Treatment',
    police: {
      usage: 'Usage',
      negative: 'Negative impact',
      ordered: 'Mandatory counseling or treatment',
      voluntary: 'Voluntary counseling or treatment',
      additional: 'Additional instances',
    },
    drugs: {
      usage: 'Usage',
      purchase: 'Purchase',
      clearance: 'Security clearance position',
      publicsafety: 'Public safety position',
      misuse: 'Prescription drug misuse',
      ordered: 'Mandatory counseling or treatment',
      voluntary: 'Voluntary counseling or treatment',
      supplementalpublicsafety: 'Supplemental public safety position',
      supplementalusage: 'Supplemental usage',
    },
    review: 'Review substance use',
  },
  alcohol: {
    heading: {
      negativeImpact:
        'In the last seven (7) years has your use of alcohol had a negative impact on your work performance, your professional or personal relationships, your finances, or resulted in intervention by law enforcement/public safety personnel?',
      orderedCounseling:
        'Have you EVER been ordered, advised, or asked to seek counseling or treatment as a result of your use of alcohol?',
      orderedCounselingNum:
        'In the last {{numberOfYearsString}} have you been ordered, advised, or asked to seek counseling or treatment as a result of your use of alcohol?',
      voluntaryCounseling:
        'Have you EVER voluntarily sought counseling or treatment as a result of your use of alcohol?',
      voluntaryCounselingNum:
        'In the last {{numberOfYearsString}} have you voluntarily sought counseling or treatment as a result of your use of alcohol?',
      receivedCounseling:
        'Have you EVER received counseling or treatment as a result of your use of alcohol in addition to what you have already listed on this form?',
      anyCounseling:
        'In the last 5 years, has your use of alcoholic beverages (such as liquor, beer, wine) resulted in any alcohol-related treatment or counseling (such as for alcohol abuse or alcoholism)?'
    },
    negativeImpact: {
      heading: {
        occurred: 'Provide the month/year when this negative impact occurred',
        circumstances: 'Provide an explanation of the circumstances and the negative impact',
        used: 'Provide dates of involvement or use',
      },
      label: {
        circumstances: 'Provide circumstances',
        negativeImpact: 'Provide negative impact',
      },
      help: {
        occurred: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        circumstances: {
          title: 'Need help with the circumstances?',
          message: 'Provide an explanation of the circumstances and the negative impact',
          note: '',
        },
        used: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
      collection: {
        description: 'Summary of negative impacts',
        summary: 'Provide your negative impact details below',
        appendTitle:
          'Has the use of alcohol had other negative impacts on your work performance, your professional or personal relationships, your finances, or resulted in intervention by law enforcement/public safety personnel?',
        appendLabel: 'Add another negative impact',
        itemType: 'Negative impact',
      },
    },
    orderedCounseling: {
      heading: {
        seekers:
          'Have any of the following ordered, advised, or asked you to seek counseling or treatment as a result of your use of alcohol?',
        actionTaken: 'Did you take action to seek counseling or treatment?',
        noActionTakenExplanation:
          'You responded ‘No’ to having taken action to seek counseling or treatment. Explain the reasons for not taking action to seek counseling or treatment.',
        counselingDates: 'Provide the dates of counseling or treatment',
        treatmentProviderName: 'Provide the name of the individual counselor or treatment provider',
        treatmentProviderAddress: 'Provide the full address of the counseling/treatment provider',
        treatmentProviderTelephone: 'Provide telephone number',
        completedTreatment: 'Did you successfully complete the treatment program?',
        noCompletedTreatment:
          'You responded “No” to having successfully completed the treatment program. Provide explanation.',
      },
      label: {
        seekers: 'Check all that apply',
        otherSeeker: 'Provide explanation',
      },
      seekers: {
        label: {
          employer: 'An employer, military commander, or employee assistance program',
          medicalProfessional: 'A medical professional',
          mentalHealthProfessional: 'A mental health professional',
          courtOfficial: 'A court official / judge',
          notOrdered:
            'I have not been ordered, advised, or asked to seek counseling or treatment by any of the above',
          other: 'Other (provide explanation)',
        },
      },
      collection: {
        description: 'Summary of counselings',
        summary: 'Provide your counseling details below',
        appendTitle:
          'Do you have additional instances of having been ordered, advised or asked to seek counseling or treatment as a result of your use of alcohol to enter?',
        appendLabel: 'Add another counseling',
        itemType: 'Counseling',
      },
      help: {
        seekers: {
          title: 'Need help with determining who has ordered you to seek treatment?',
          message:
            'Check all who ordered, advised, or asked you to seek counseling or treatment as a result of your use of alcohol',
          note: '',
        },
        counselingDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        actionTaken: {
          title: 'Need help with action taken to seek counseling or treatment',
          message: 'Select if you have taken action to seek counseling or treatment.',
          note: '',
        },
        treatmentProviderName: {
          title: 'Need help with the treatment provider name?',
          message: 'Provide the name of the individual counselor or treatment provider',
          note: '',
        },
        treatmentProviderAddress: {
          title:
            "Try looking up the treatment provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        treatmentProviderTelephone: {
          title: 'Look up the treatment provider',
          message:
            "Try looking up the treatment provider's name, this could help you find the phone number.",
          note: '',
        },
        completedTreatment: {
          title: 'Need help with your treatment completion?',
          message: 'Mark if you successfully completed a treatment program',
          note: '',
        },
      },
    },
    voluntaryCounseling: {
      heading: {
        counselingDates: 'Provide the dates of counseling or treatment',
        treatmentProviderName: 'Provide the name of the individual counselor or treatment provider',
        treatmentProviderAddress: 'Provide the full address of the counseling/treatment provider',
        treatmentProviderTelephone: 'Provide telephone number',
        completedTreatment: 'Did you successfully complete the treatment program?',
        noCompletedTreatment:
          'You responded “No” to having successfully completed the treatment program. Provide explanation.',
      },
      collection: {
        description: 'Summary of counselings',
        summary: 'Provide your counseling details below',
        appendTitle:
          'Do you have additional instances where you have voluntarily sought counseling or treatment as a result of your use of alcohol to enter?',
        appendLabel: 'Add another counseling',
        itemType: 'Counseling',
      },
      help: {
        counselingDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentProviderName: {
          title: 'Need help with the treatment provider name?',
          message: 'Provide the name of the individual counselor or treatment provider',
          note: '',
        },
        treatmentProviderAddress: {
          title:
            "Try looking up the treatment provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        treatmentProviderTelephone: {
          title: 'Look up the treatment provider',
          message:
            "Try looking up the treatment provider's name, this could help you find the phone number.",
          note: '',
        },
        completedTreatment: {
          title: 'Need help with your treatment completion?',
          message: 'Mark if you successfully completed a treatment program',
          note: '',
        },
        noCompletedTreatment: {
          title: 'Need help with this explanation?',
          message:
            'Provide details as to why you responded No to having successfully completed the treatment program',
          note: '',
        },
      },
    },
    receivedCounseling: {
      heading: {
        counselingDates: 'Provide the dates of counseling or treatment',
        treatmentProviderName: 'Provide the name of the individual counselor or treatment provider',
        treatmentProviderAddress: 'Provide the full address of the counseling/treatment provider',
        agencyName:
          'Provide the name of agency/organization where counseling/treatment was provided',
        agencyAddress:
          'Provide the address of agency/organization where counseling/treatment was provided',
        completedTreatment: 'Did you successfully complete your counseling or treatment?',
        treatmentBeganDate: 'Provide the date counseling or treatment began',
        treatmentEndDate: 'Provide the date counseling or treatment ended',
        noCompletedTreatment: 'Provide explanation',
      },
      collection: {
        description: 'Summary of counselings',
        summary: 'Provide your counseling details below',
        appendTitle: 'Did you receive alcohol-related counseling or treatment another time?',
        appendLabel: 'Add another counseling',
        itemType: 'Counseling',
      },
      help: {
        counselingDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentProviderName: {
          title: 'Need help with the treatment provider name?',
          message: 'Provide the name of the individual counselor or treatment provider',
          note: '',
        },
        treatmentProviderAddress: {
          title:
            "Try looking up the treatment provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        agencyName: {
          title: 'Need help with the agency name?',
          message:
            'Provide the name of agency/organization where counseling/treatment was provided',
          note: '',
        },
        agencyAddress: {
          title: "Try looking up the agency's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        treatmentBeganDate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentEndDate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        completedTreatment: {
          title: 'Need help with your treatment completion?',
          message: 'Mark if you successfully completed a treatment program',
          note: '',
        },
        noCompletedTreatment: {
          title: 'Need help with this explanation?',
          message:
            'Provide details as to why you responded No to having successfully completed the treatment program',
          note: '',
        },
      },
    },
    anyCounseling: {
      heading: {
        counselingSummaryComment: 'Optional Summary Comment',
        alcoholTreatmentOrCounselingComment: 'Optional Comment',
        consultationComment: 'Optional Comment',
        treatmentProviderName: 'Provide the name of the counselor or doctor',
        counselingDates: 'Provide the dates of treatment',
        treatmentProviderAddress: 'Provide the address of the counselor or doctor',
      },
      collection: {
        description: 'Summary of counselings',
        summary: 'Provide your counseling details below',
        appendTitle:
          'Do you have an additional instance of having your use of alcohol beverages (such as liquor, beer, wine) result in any alcohol-related treatment or conseling (such as for alcohol abuse or alcoholism) in the last 5 years to enter?',
        appendLabel: 'Add another counseling',
        itemType: 'Counseling',
      },
      help: {
        counselingDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentProviderAddress: {
          title: "Try looking up the provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
      },
    },
  },
  drugs: {
    heading: {
      drugUses:
        'In the last {{numberOfYearsString}}, have you illegally used any drugs or controlled substances?',
      drugInvolvement:
        'In the last {{numberOfYearsString}}, have you been involved in the illegal purchase, manufacture, cultivation, trafficking, production, transfer, shipping, receiving, handling or sale of any drug or controlled substance?',
      drugClearanceUses:
        'Have you EVER illegally used or otherwise been illegally involved with a drug or controlled substance while possessing a security clearance other than previously listed?',
      drugPublicSafetyUses:
        'Have you EVER illegally used or otherwise been involved with a drug or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety other than previously listed?',
      drugPublicSafetyUsesNum:
        'In the last {{numberOfYearsString}} have you illegally used or otherwise been involved with a drug or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety other than previously listed?',
      prescriptionUses:
        'In the last {{numberOfYearsString}} have you intentionally engaged in the misuse of prescription drugs, regardless of whether or not the drugs were prescribed for you or someone else?',
      orderedTreatments:
        'In the last {{numberOfYearsString}} have you been ordered, advised, or asked to seek counseling or treatment as a result of your illegal use of drugs or controlled substances?',
      orderedTreatmentsEver:
        'Have you EVER been ordered, advised, or asked to seek counseling or treatment as a result of your illegal use of drugs or controlled substances?',
      voluntaryTreatments:
        'In the last {{numberOfYearsString}} have you voluntarily sought counseling or treatment as a result of your use of a drug or controlled substance?',
      voluntaryTreatmentsEver:
        'Have you EVER voluntarily sought counseling or treatment as a result of your use of a drug or controlled substance?',
      supplementalUsage: 'Since the age of 16 or in the last 5 years, whichever is shorter, have you illegally used any controlled substance, for example, marijuana, cocaine, crack cocaine, hashish, narcotics (opium, morphine, codeine, heroine, etc.), amphetamines, depressants (barbiturates, methaqualone, tranquilizers, etc.), hallucinogenics (LSD, PCP, etc.) or prescription drugs?',
      supplementalPublicSafety: 'Have you ever illegally used a controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; while possessing a security clearance; or while in a position directly and immediately affecting the public safety?'
    },
    para: {
      drugUses:
        'We note, with reference to this section, that neither your truthful responses nor information derived from your responses to this section will be used as evidence against you in a subsequent criminal proceeding. This particular section applies whether or not you are currently employed by the Federal government. The following questions pertain to the illegal use of drugs or controlled substances or drug or controlled substance activity not in accordance with Federal laws, even though permissible under state laws.',
    },
    use: {
      heading: {
        drugType: 'Provide the type of drug or controlled substance',
        firstUse: 'Provide an estimate of the month and year of first use',
        recentUse: 'Provide an estimate of the month and year of most recent use',
        natureOfUse: 'Provide nature of use, frequency, and number of times used',
        useWhileEmployed:
          'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
        useWithClearance: 'Was your use while possessing a security clearance?',
        useInFuture: 'Do you intend to use this drug or controlled substance in the future?',
        explanation:
          'Provide explanation of why you intend or do not intend to use this drug or controlled substance in the future',
      },
      para: {
        drugUses:
          'Use of a drug or controlled substance includes injecting, snorting, inhaling, swallowing, experimenting with or otherwise consuming any drug or controlled substance.',
      },
      help: {
        drugType: {
          title: 'Need help with the drug type?',
          message: 'Provide the type of drug or controlled substance used',
          note: '',
        },
        firstUse: {
          title: 'Need help with the date of first use?',
          message: 'Provide an estimate of the month and year of first use',
          note: '',
        },
        recentUse: {
          title: 'Need help with the date of most recent use?',
          message: 'Provide an estimate of the month and year of first use',
          note: '',
        },
        natureOfUse: {
          title: 'Need help with the nature of drug use?',
          message: 'Provide nature of use, frequency, and number of times used',
          note: '',
        },
        useWhileEmployed: {
          title: 'Need help with the use?',
          message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
          note: '',
        },
        useWithClearance: {
          title: 'Need help with the drug use with a security clearance?',
          message: 'Was your use while possessing a security clearance?',
          note: '',
        },
        useInFuture: {
          title: 'Need help with the drug use in the future?',
          message: 'Mark if you intend to use this drug or controlled substance in the future',
          note: '',
        },
        explanation: {
          title: 'Need help with the explanation?',
          message:
            'Provide explanation of why you intend or do not intend to use this drug or controlled substance in the future',
          note: '',
        },
      },
      collection: {
        description: 'Summary of drug uses',
        summary: 'Provide your drug use details below',
        appendTitle:
          'Do you have an additional instance(s) of illegal use of a drug or controlled substance to enter?',
        appendLabel: 'Add another drug use',
        itemType: 'Drug Use',
      },
    },
    involvement: {
      heading: {
        drugType: 'Provide the type of drug or controlled substance',
        firstInvolvement: 'Provide an estimate of the month and year of first involvement',
        recentInvolvement: 'Provide an estimate of the month and year of most recent involvement',
        natureOfInvolvement: 'Provide nature of and frequency of activity',
        involvementWhileEmployed:
          'Was your involvement while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
        involvementWithClearance: 'Was your involvement while possessing a security clearance?',
        involvementInFuture: 'Do you intend to engage in this activity in the future?',
        reasons: 'Provide the reason(s) why you engaged in the activity',
        explanation:
          'You have indicated that you plan to engage in the illegal purchase, manufacture, cultivation, trafficking, production, transfer, shipping, receiving, handling or sale of a drug or controlled substance in the future. Provide explanation.',
      },
      help: {
        drugType: {
          title: 'Need help with the drug type?',
          message: 'Provide the type of drug or controlled substance used',
          note: '',
        },
        firstInvolvement: {
          title: 'Need help with the date of first involvement?',
          message: 'Provide an estimate of the month and year of first involvement',
          note: '',
        },
        recentInvolvement: {
          title: 'Need help with the date of most recent involvement?',
          message: 'Provide an estimate of the month and year of first involvement',
          note: '',
        },
        natureOfInvolvement: {
          title: 'Need help with the nature of drug involvement?',
          message: 'Provide nature of use, frequency, and number of times used',
          note: '',
        },
        involvementWhileEmployed: {
          title: 'Need help with the use?',
          message:
            'Was your use while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
          note: '',
        },
        involvementWithClearance: {
          title: 'Need help with the drug use with a security clearance?',
          message: 'Was your use while possessing a security clearance?',
          note: '',
        },
        involvementInFuture: {
          title: 'Need help with the drug use in the future?',
          message: 'Mark if you intend to use this drug or controlled substance in the future',
          note: '',
        },
        reasons: {
          title: 'Need help with the reasoning?',
          message: 'Provide the reason(s) why you engaged in the activity',
          note: '',
        },
        explanation: {
          title: 'Need help with the explanation?',
          message:
            'Provide explanation of why you intend or do not intend to use this drug or controlled substance in the future',
          note: '',
        },
      },
      collection: {
        description: 'Summary of drug involvement',
        summary: 'Provide your drug involvement details below',
        appendTitle:
          'Do you have an additional instance(s) of having been involved in the illegal purchase, manufacture, cultivation, trafficking, production, transfer, shipping, receiving, handling or sale of a drug or controlled substance to enter?',
        appendLabel: 'Add another drug involvement',
        itemType: 'Drug involvement',
      },
    },
    clearance: {
      heading: {
        description: 'Provide a description of your involvement',
        involvementDates: 'Provide the dates of involvement/use',
        estimatedUse:
          'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while possessing a security clearance',
      },
      help: {
        description: {
          title: 'Need help with the description?',
          message: 'Provide a description of your involvement',
          note: '',
        },
        involvementDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        estimatedUse: {
          title: 'Need help with the estimated times used?',
          message:
            'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while possessing a security clearance',
          note: '',
        },
      },
      collection: {
        description: 'Summary of drug involvement',
        summary: 'Provide your drug involvement details below',
        appendTitle:
          'Do you have an additional instance(s) of the illegal use or involvement with a drug or controlled substance while possessing a security clearance to enter?',
        appendLabel: 'Add another drug involvement',
        itemType: 'Drug involvement',
      },
    },
    publicSafety: {
      heading: {
        description:
          'Provide a description of the drugs or controlled substances used and your involvement',
        involvementDates: 'Provide the dates of involvement/use',
        estimatedUse:
          'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while employed in this capacity',
      },
      help: {
        description: {
          title: 'Need help with the description?',
          message: 'Provide a description of your involvement',
          note: '',
        },
        involvementDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        estimatedUse: {
          title: 'Need help with the estimated times used?',
          message:
            'Provide an estimate of the number of times you used and/or were involved with this drug or controlled substance while possessing a security clearance',
          note: '',
        },
      },
      collection: {
        description: 'Summary of drug involvement',
        summary: 'Provide your drug involvement details below',
        appendTitle:
          'Do you have an additional instance(s) of illegal use or involvement with a drug or controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; or while in a position directly and immediately affecting the public safety to enter?',
        appendLabel: 'Add another drug involvement',
        itemType: 'Drug involvement',
      },
    },
    prescription: {
      heading: {
        prescriptionName: 'Provide the name of the prescription drug that you misused',
        involvementDates: 'Provide the dates of involvement in the above',
        reason:
          'Provide the reason(s) for and circumstances of the misuse of the prescription drug',
        useWhileEmployed:
          'Was your involvement while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
        useWithClearance: 'Was your involvement while possessing a security clearance?',
      },
      help: {
        prescriptionName: {
          title: 'Need help with the prescriptin name?',
          message: 'Provide the name of the prescription drug that you misused',
          note: '',
        },
        reason: {
          title: 'Need help with the reason?',
          message:
            'Provide the reason(s) for and circumstances of the misuse of the prescription drug',
          note: '',
        },
        involvementDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        useWhileEmployed: {
          title: 'Need help with the use?',
          message:
            'Was your involvement while you were employed as a law enforcement officer, prosecutor, or courtroom official, or while in a position directly and immediately affecting the public safety?',
          note: '',
        },
        useWithClearance: {
          title: 'Need help with the drug use with a security clearance?',
          message: 'Was your involvement while possessing a security clearance?',
          note: '',
        },
      },
      collection: {
        description: 'Summary of drug misuse',
        summary: 'Provide your drug misuse details below',
        appendTitle:
          'Do you have an additional instance(s) of intentionally engaging in the misuse of prescription drugs in the last {{numberOfYearsString}} to enter?',
        appendLabel: 'Add another drug misuse',
        itemType: 'Drug misuse',
      },
    },
    ordered: {
      heading: {
        orderedBy:
          'Have any of the following ordered, advised, or asked you to seek counseling or treatment as a result of your illegal use of drugs or controlled substances?',
        explanation: 'Provide explanation',
        actionTaken: 'Did you take action to receive counseling or treatment?',
        noActionTakenExplanation:
          'You have indicated that you did not receive treatment. Provide explanation',
        drugType: 'Provide the type of drug or controlled substance for which you were treated',
        treatmentProvider: 'Provide the name of the treatment provider',
        treatmentProviderAddress: 'Provide the address for this treatment provider',
        treatmentProviderTelephone: 'Provide a telephone number for the treatment provider',
        treatmentDates: 'Provide the dates of treatment',
        treatmentCompleted: 'Did you successfully complete the treatment?',
        noTreatmentExplanation:
          'You have indicated that you did not successfully complete the treatment. Provide explanation.',
      },
      para: {
        orderedBy: 'Check all that apply',
        treatmentProviderFirstName: 'First name',
        treatmentProviderLastName: 'Last name',
      },
      help: {
        drugType: {
          title: 'Need help with the drug type?',
          message: 'Provide the type of drug or controlled substance used',
          note: '',
        },
        orderedBy: {
          title: 'Need help with who ordered treatment?',
          message:
            'Have any of the following ordered, advised, or asked you to seek counseling or treatment as a result of your illegal use of drugs or controlled substances?',
          note: '',
        },
        explanation: {
          title: 'Need help with the explanation?',
          message: 'Provide explanation',
          note: '',
        },
        actionTaken: {
          title: 'Need help with taking action to receive counseling or treatment?',
          message: 'Mark if you took action to receive counseling or treatment',
          note: '',
        },
        noActionTakenExplanation: {
          title: 'Need help with not having taken action?',
          message: 'Provide explanation as to why you did not receive treatment',
          note: '',
        },
        treatmentProvider: {
          title: 'Need help with the treatment provider?',
          message: 'Provide the name of the treatment provider',
          note: '',
        },
        treatmentProviderAddress: {
          title: "Try looking up the provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        treatmentProviderTelephone: {
          title: 'Look up the provider',
          message: "Try looking up the provider's name, this could help you find the phone number.",
          note: '',
        },
        treatmentDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentCompleted: {
          title: 'Need help with the treatment completion?',
          message: 'Mark yes if you successfully completed the treatment',
          note: '',
        },
        noTreatmentExplanation: {
          title: 'Need help with the explanation for not completing treatment?',
          message: 'Explain why you did not complete treatment',
          note: '',
        },
      },
      collection: {
        description: 'Summary of treatments',
        summary: 'Provide your treatment details below',
        appendTitle:
          'Do you have another instance of having been ordered, advised, or asked to seek drug or controlled substance counseling or treatment to enter?',
        appendLabel: 'Add another treatment',
        itemType: 'Treatment',
      },
      orderedBy: {
        label: {
          employer: 'An employer, military commander, or employee assistance program',
          medicalProfessional: 'A medical professional',
          mentalHealthProfessional: 'A mental health professional',
          judge: 'A court official / judge',
          none:
            'I have not been ordered, advised, or asked to seek counseling or treatment by any of the above.',
        },
      },
    },
    voluntary: {
      heading: {
        drugType: 'Provide the type of drug or controlled substance for which you were treated',
        treatmentProvider: 'Provide the name of the treatment provider',
        treatmentProviderAddress: 'Provide the address for this treatment provider',
        treatmentProviderTelephone: 'Provide a telephone number for the treatment provider',
        treatmentDates: 'Provide the dates of treatment',
        treatmentCompleted: 'Did you successfully complete the treatment?',
        noTreatmentExplanation:
          'You have indicated that you did not you successfully complete the treatment. Provide explanation.',
      },
      para: {
        treatmentProviderFirstName: 'First name',
        treatmentProviderLastName: 'Last name',
      },
      help: {
        drugType: {
          title: 'Need help with the drug type?',
          message: 'Provide the type of drug or controlled substance used',
          note: '',
        },
        treatmentProvider: {
          title: 'Need help with the treatment provider?',
          message: 'Provide the name of the treatment provider',
          note: '',
        },
        treatmentProviderAddress: {
          title: "Try looking up the provider's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        treatmentProviderTelephone: {
          title: 'Look up the provider',
          message: "Try looking up the provider's name, this could help you find the phone number.",
          note: '',
        },
        treatmentDates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates gives us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        treatmentCompleted: {
          title: 'Need help with the treatment completion?',
          message: 'Mark yes if you successfully completed the treatment',
          note: '',
        },
        noTreatmentExplanation: {
          title: 'Need help with the explanation for not completing treatment?',
          message: 'Explain why you did not complete treatment',
          note: '',
        },
      },
      collection: {
        description: 'Summary of treatments',
        summary: 'Provide your treatment details below',
        appendTitle:
          'Do you have another instance of voluntarily seeking counseling or treatment as a result of your use of a drug or controlled substance in the last {{numberOfYearsString}}?',
        appendTitleEver:
          'Do you have another instance of EVER voluntarily seeking counseling or treatment as a result of your use of a drug or controlled substance?',
        appendLabel: 'Add another treatment',
        itemType: 'Treatment',
      },
      orderedBy: {
        label: {
          employer: 'An employer, military commander, or employee assistance program',
          medicalProfessional: 'A medical professional',
          mentalHealthProfessional: 'A mental health professional',
          judge: 'A court official / judge',
          none:
            'I have not been ordered, advised, or asked to seek counseling or treatment by any of the above.',
        },
      },
    },
    supplementalPublicSafety: {
      heading: {
        drugUsed: 'Identify the controlled substance and/or prescription drug used',
        dateRange: 'Provide the dates used',
        numberOfTimesUsed: 'Provide the number of times used',
        comment: 'Optional Comment',
        branchComment: 'Optional Comment',
        summaryComment: 'Optional Summary Comment'
      },
      help: {
        drugUsed: {
          title: 'Need help with the the controlled substance and/or prescription drug used?',
          message: 'Provide a description of your involvement',
          note: '',
        },
        dateRange: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        numberOfTimesUsed: {
          title: 'Need help with the number of times used?',
          message:
            'Provide the number of times the controlled substance and/or prescription drug was used',
          note: '',
        },
      },
      collection: {
        description: 'Summary of controlled substance involvement',
        summary: 'Provide your controlled substance involvement details below',
        appendTitle:
          'Do you have an additional instance of having ever illegally used a controlled substance while employed as a law enforcement officer, prosecutor, or courtroom official; while possessing a security clearance; or while in a position directly and immediately affecting the public safety to enter?',
        appendLabel: 'Add another controlled substance involvement',
        itemType: 'Supplemental public safety instance',
      },
    },
    supplementalUsage: {
      heading: {
        drugUsed: 'Identify the controlled substance and/or prescription drug used',
        dateRange: 'Provide the dates used',
        numberOfTimesUsed: 'Provide the number of times used',
        comment: 'Optional Comment',
        branchComment: 'Optional Comment',
        summaryComment: 'Optional Summary Comment'
      },
      help: {
        drugUsed: {
          title: 'Need help with the the controlled substance and/or prescription drug used?',
          message: 'Provide a description of your involvement',
          note: '',
        },
        dateRange: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        numberOfTimesUsed: {
          title: 'Need help with the number of times used?',
          message:
            'Provide the number of times the controlled substance and/or prescription drug was used',
          note: '',
        },
      },
      collection: {
        description: 'Summary of controlled substance involvement',
        summary: 'Provide your controlled substance involvement details below',
        appendTitle:
          'Do you have an additional instance of having illegally used any controlled substance or prescription drugs since the age of 16 or in the last 5 years, whichever is shorter, to enter?',
        appendLabel: 'Add another controlled substance involvement',
        itemType: 'Supplemental usage instance',
      },
    },

    drugType: {
      label: {
        cocaine: 'Cocaine or crack cocaine (Such as rock, freebase, etc.)',
        stimulants: 'Stimulants (Such as amphetamines, speed, crystal meth, ecstasy, etc.)',
        thc: 'THC (Such as marijuana, weed, pot, hashish, etc.)',
        depressants: 'Depressants (Such as barbiturates, methaqualone, tranquilizers, etc.)',
        ketamine: 'Ketamine (Such as special K, jet, etc.)',
        narcotics: 'Narcotics (Such as opium, morphine, codeine, heroin, etc.)',
        hallucinogenic: 'Hallucinogenic (Such as LSD, PCP, mushrooms, etc.)',
        steroids: 'Steroids (Such as the clear, juice, etc.)',
        inhalants: 'Inhalants (Such as toluene, amyl nitrate, etc.)',
        other: 'Other (Provide explanation)',
        drugTypeOther: 'Provide explanation',
      },
    },
  },
};
